
document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('.product__tax');
  const insertAfterElement = document.querySelector('.tee-product-price');
  if (elementToMove && insertAfterElement) {        
   insertAfterElement.after(elementToMove)
  } 

  const elementToMove2 = document.querySelector('.avada-badge-v2-app_block');
  const insertAfterElement2 = document.querySelector('#teeFormActions');
  if (elementToMove2 && insertAfterElement2) {        
   insertAfterElement2.after(elementToMove2)
  } 
});

setTimeout(() =>{
  const cartItemList = document.querySelectorAll('tr.cart-item')
  if(cartItemList){
    cartItemList.forEach((item) =>{
    const options = item.querySelectorAll('.cart-item__details .product-option')
    options.forEach((op) =>{
      if( op.textContent.includes('customization_id:')){
        op.remove()
      }
    })
  })
  }

  const itemCartDawns = document.querySelectorAll('div.qsc2-product-item__property')
  if(itemCartDawns){
    itemCartDawns.forEach((itemCartDawn) =>{
      if( itemCartDawn.textContent.includes('customization_id:')){
        itemCartDawn.remove()
      }
    })
  }
  },2000)

document.addEventListener("teeinblue-event-component-injected",function(){
 const btnAddToCart = document.querySelector('#teeAtcButton')
  btnAddToCart.addEventListener('click', function(){
        let interval = 500; 
        let maxAttempts = 10; 
        let attempts = 0;
        let intervalId = setInterval(function() {
          attempts++;
          let element = document.querySelector('.qsc2-mini-cart:not(.qsc2-drawer--hidden)');
          if (element) {
              const itemCartDawns = document.querySelectorAll('div.qsc2-product-item__property')
              if(itemCartDawns){
                itemCartDawns.forEach((itemCartDawn) =>{
                  if( itemCartDawn.textContent.includes('customization_id:')){
                    itemCartDawn.remove()
                  }
                })
              }
          } else if (attempts >= maxAttempts) {
              console.log('Element not found within 10 seconds.');
              clearInterval(intervalId);
          }
        }, interval);
      })
})

